<div class="layout-container">
  <div class="title-container">
    <h3 class="title">
      {{ 'INVENTORY_UI.ITEM_SELECTION_CART.TITLE' | translate }}
    </h3>
    <span class="button-container">
      <a mat-button color="primary" (click)="removeAll()" [disabled]="cartItems()?.length < 1">
        {{ 'INVENTORY_UI.COMMON.ACTIONS.CLEAR' | translate }}
      </a>
    </span>
  </div>

  <inventory-ui-item-list [items]="cartItems()!" [removeButtonEnabled]="true" (itemRemoved)="removeItem($event)" />
</div>
